import { DrawerBody, InlineDrawer } from "@fluentui/react-components";
import { useSetAtom } from "jotai";
import { sizes } from "library/constants";
import { ROUTES } from "library/routes";
import { useTranslation } from "react-i18next";
import { chatPanelOpenAtom } from "store";

import { BenefitsIcon } from "components/AppLayout/icons/BenefitsIcon";
import { DashboardIcon } from "components/AppLayout/icons/DashboardIcon";
import { WalletIcon } from "components/AppLayout/icons/WalletIcon";
import { Flex } from "components/styled";
import { helpAnchor } from "help/anchor";
import { useAppTheme } from "hooks/useAppTheme";
import { useIsMobile } from "hooks/useIsMobile";

import { MobileNavItem } from "./MobileNavItem";

import { ChatIcon } from "../icons/ChatIcon";

function AppMobileNavigation() {
  const theme = useAppTheme();
  const isMobile = useIsMobile();
  const setOpenPanel = useSetAtom(chatPanelOpenAtom);
  const { t } = useTranslation();
  return (
    <InlineDrawer
      separator
      position={"bottom"}
      open={!!isMobile}
      style={{
        height: sizes.appNavHeightMobile,
        border: `1px solid  ${theme.palette.neutralLight}`,
        borderRadius: "0",
        padding: "0 16px",
        backgroundColor: theme.palette.white,
        position: "fixed",
        bottom: 0,
        zIndex: 9999,
        boxShadow: `0px -4px 6px -2px ${theme.palette.neutralLight}`,
      }}
    >
      <DrawerBody
        style={{
          padding: 0,
          overflow: "hidden",
        }}
      >
        <Flex
          $gap={"5px"}
          dir="row"
          $justify="space-around"
          style={{
            height: "100%",
          }}
        >
          <MobileNavItem
            label={"Benefits"}
            pageRoute={ROUTES.BENEFITS}
            Icon={BenefitsIcon}
            helpAnchorName={helpAnchor("nav-benefits")}
          />
          <MobileNavItem
            pageRoute={ROUTES.DASHBOARD}
            label={"Dashboard"}
            Icon={DashboardIcon}
            helpAnchorName={helpAnchor("nav-dashboard")}
          />
          {/* <MobileNavItem disabled pageRoute={ROUTES.WALLET} label={"Wallet"} Icon={WalletIcon} /> */}
          <MobileNavItem
            btnAction={() => {
              setOpenPanel(true);
            }}
            label={t("hbh.askQuestion.label")}
            Icon={ChatIcon}
            helpAnchorName={helpAnchor("app-chat-toggle")}
          />
        </Flex>
      </DrawerBody>
    </InlineDrawer>
  );
}

export default AppMobileNavigation;
